import { Link, useLocation } from "react-router-dom";
import ProgressSteps from "../../../components/ProgressSteps";
import { useEffect } from "react";

export default function ProSignupSuccess() {
  const location = useLocation();
  const apiSuccess = Boolean((location.state as { apiSuccess?: boolean } | null)?.apiSuccess);

  useEffect(() => {
    if (apiSuccess) return;
    try {
      const raw = localStorage.getItem("pro.signup");
      if (raw) {
        const { nom, prenom, email } = JSON.parse(raw) as { nom?: string; prenom?: string; email?: string };
        let derivedNom = nom;
        let derivedPrenom = prenom;
        if ((!derivedNom || !derivedPrenom) && email) {
          const local = String(email).split("@")[0] || "";
          const parts = local.replace(/[._-]+/g, " ").trim().split(/\s+/);
          const cap = (value: string) => (value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "");
          derivedPrenom = derivedPrenom || cap(parts[0] || "Professionnel");
          derivedNom = derivedNom || cap(parts[1] || "");
        }
        if (derivedNom || derivedPrenom || email) {
          localStorage.setItem("pro.user", JSON.stringify({ nom: derivedNom, prenom: derivedPrenom, email }));
          try {
            const registryRaw = localStorage.getItem("pro.registry");
            const registry = registryRaw ? JSON.parse(registryRaw) : {};
            if (email) registry[email] = { nom: derivedNom, prenom: derivedPrenom };
            localStorage.setItem("pro.registry", JSON.stringify(registry));
          } catch {
            /* ignore */
          }
        }
        localStorage.removeItem("pro.signup");
      }
    } catch {
      /* ignore */
    }
  }, [apiSuccess]);

  return (
    <div className="relative h-screen overflow-hidden">
      <img src={import.meta.env.BASE_URL + 'maps-reset-side.jpg'} alt="pro-signup-success" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/30" />

      <div className="absolute inset-0 z-10 px-4 md:px-8 py-6 md:py-8 flex">
        <div className="max-w-6xl mx-auto flex flex-col w-full">
          <div className="pl-2 md:pl-6 pt-2 md:pt-4">
            <Link to="/professionnel/connexion" className="inline-flex items-center gap-2 text-white/90">← Retour</Link>
          </div>

          <div className="mt-auto flex items-end justify-between gap-6 pl-2 md:pl-6 pr-4 md:pr-8 pb-4 md:pb-8">
            <div className="w-full max-w-2xl bg-white/95 backdrop-blur rounded-[12px] shadow p-8 md:p-10">
              <h1 className="text-2xl font-semibold" style={{ color: '#0B1F16' }}>Création de compte</h1>
              <div className="mt-6 text-xl font-semibold" style={{ color: '#0B1F16' }}>
                Votre compte a été créé avec succès !
              </div>
              <p className="mt-3 text-sm" style={{ color: '#00553E' }}>
                Un lien vous a été envoyé par mail. Veuillez utiliser ce lien pour effectuer votre première connexion.
              </p>
              <div className="mt-12">
                <ProgressSteps step={4} total={4} />
              </div>
              <div className="mt-6">
                <Link to="/professionnel/connexion" className="inline-flex items-center h-14 px-6 rounded-[10px] font-semibold text-white cursor-pointer" style={{ background: '#00553E' }}>
                  Aller à la connexion
                </Link>
              </div>
              <p className="mt-4 text-sm text-gray-600">
                Une fois connecté, retrouvez le menu « Vérification d&apos;identité » dans votre tableau de bord pour
                soumettre votre carte CIP et votre attestation d&apos;inscription à l&apos;Ordre.
              </p>
            </div>
            <div className="hidden md:block shrink-0">
              <img src={import.meta.env.BASE_URL + 'Group 5.png'} alt="agabaza-logo" className="w-auto" style={{ height: 144 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

